import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { PendenciaMotivoDBService } from '../database/pendencia-motivo-db.service';

@Injectable({
  providedIn: 'root'
})
export class PendenciaMotivoService extends BaseService {
    override classname: string = 'PendenciaMotivoService';
    public override route: string = 'pendencia-motivo';

    public override database = new PendenciaMotivoDBService();
}
